var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "list-item" }, [
      _c(
        "a",
        {
          attrs: {
            href: `${_vm.baseUrl}${this.company.name}/${this.company.id}/`
          }
        },
        [
          _c("div", { staticClass: "logo-container" }, [
            _c(
              "object",
              {
                attrs: {
                  data: _vm.company.logo,
                  type: "image/png",
                  alt: _vm.company.name
                }
              },
              [
                _c("img", {
                  attrs: {
                    src:
                      "/wp-content/themes/kwankotheme/assets/images/program_directory/program_default.svg",
                    alt: _vm.company.name
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "object",
              {
                key: _vm.country,
                staticClass: "geo",
                attrs: {
                  alt: _vm.country,
                  title: _vm.country,
                  data: `/wp-content/themes/kwankotheme/assets/images/flags/${_vm.country.toLowerCase()}.svg`,
                  type: "image/svg+xml"
                }
              },
              [
                _c("img", {
                  attrs: {
                    src:
                      "/wp-content/themes/kwankotheme/assets/images/flags/world.svg",
                    alt: _vm.country
                  }
                })
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "company-info" }, [
        _c(
          "a",
          {
            attrs: {
              href: `${_vm.baseUrl}${this.company.name}/${this.company.id}/`
            }
          },
          [
            _c("h4", [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.company.name) +
                  "\n                "
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("p", { domProps: { innerHTML: _vm._s(_vm.descriptionHandler) } })
      ]),
      _vm._v(" "),
      _vm.campaignCategories.length
        ? _c("div", { staticClass: "categories" }, [
            _c(
              "div",
              { staticClass: "categories-container" },
              _vm._l(_vm.campaignCategories, function(category) {
                return _c("span", { key: category }, [_vm._v(_vm._s(category))])
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.company.payout_types
        ? _c(
            "div",
            { staticClass: "commission" },
            [
              _c("h5", [_vm._v("Commission: ")]),
              _vm._v(" "),
              _vm._l(_vm.payouts, function(payout) {
                return _c("div", { key: payout.icon, staticClass: "payout" }, [
                  _c("img", {
                    attrs: {
                      src: `/wp-content/themes/kwankotheme/assets/images/program_directory/${payout.icon}.svg`,
                      alt: payout.icon
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(" " + _vm._s(payout.text))])
                ])
              })
            ],
            2
          )
        : _c("div", { staticClass: "commission" }, [
            _c("h5", [_vm._v("Commission: ")]),
            _vm._v(" "),
            _c("span", [_vm._v("View details")])
          ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-lg btn-block btn-cta btn-main",
          attrs: {
            href: `${_vm.baseUrl}${this.company.name}/${this.company.id}/`
          }
        },
        [_vm._v("\n            " + _vm._s(_vm.moreInfo) + "\n        ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }